export const API_URL = process.env.NODE_ENV === 'production' ? 'https://api.pingback.com' : '/api';

export const SITE_URL = process.env.NODE_ENV === 'production' ? 'pingback.com' : 'lvh.me:3001';

export const SITE_PROTOCOL = process.env.NODE_ENV === 'production' ? 'https' : 'http';

export const TEACHABLE_COURSE_ID = '1965729';